<template>
  <div class="upload-oss">
    <el-upload class="upload-demo" ref="upload" action="string" :accept="acceptType" :file-list="fileList" :drag="drag" :on-change="change" :show-file-list="false" :multiple="multiple" :auto-upload="false" :before-upload="beforeAvatarUpload">
      <slot></slot>
    </el-upload>
  </div>
</template>
<script>
import uploadApi from "@/services/api/upload/upload";
import axios from "axios";
axios.defaults.withCredentials = false;
axios.defaults.crossDomain = true;
let instance = axios.create({});
const CancelToken = axios.CancelToken;
export default {
  props: {
    upload_type: {
      //上传类型  ordinary（普通附件），database（资料库） , cross(跨团队项目), product (产品数据)
      type: String,
      default: "ordinary",
    },
    type: {
      //附件类型  attachment（附件），avatar（头像），只有ordinary时区分
      type: String,
      default: "attachment",
    },
    onlyFile: {
      type: Boolean,
    },
    pid: {
      //父级id 只有database时才有
      type: Number,
    },
    // cancelUploadItem: {
    //   ype: [Array, Object],
    //   default: () => []
    // },
    fileSize: {
      //限制文件大小 单位为MB  --- 现为手动上传，此参数暂时没用，限制须自己在上传前调用方法拦截
      type: Number,
      default: 100,
    },
    multiple: {
      //多个文件上传
      type: Boolean,
      default: true,
    },
    drag: {
      //可拖拽
      type: Boolean,
      default: false,
    },
    public: {
      type: Boolean,
      default: false,
    },
    acceptType: {
      type: String,
      default: '.jpg, .jpeg, .png, .bmp, .doc, .gif, .svg, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf, .txt ., .mp4, .avi, .f;v, .wav, .mpeg, .mov, .dat, .mpg, .zip, .rar, .tar'
    }
  },
  // watch: {
  //   cancelUploadItem(data) {
  //     if (data) {
  //       console.log(this.__cancels__)
  //       const c = axios.CancelToken
  //       console.log(c)
  //       console.log(this.fileList)
  //       console.log(data)
  //       this.$refs.upload.abort()
  //       this.$refs.upload.abort({file: data})
  //     }
  //   }
  // },
  data() {
    return {
      fileList: [],
      files: [],
      timer: "",
      count: 0,
    };
  },
  methods: {
    change(file, files) {
      if (this.onlyFile) {
        this.$emit('success', file)
        return
      }
      this.uploadCheck(file);
    },
    uploadCheck(file) {
      this.files.push(file);
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = "";
      }
      this.timer = setInterval(() => {
        this.files.forEach((res) => {
          this.uploadNow(res);
        });
        clearInterval(this.timer);
        this.timer = "";
      }, 300);
    },
    async uploadNow(file) {
      if(!this.beforeAvatarUpload(file)) return
      let _this = this;
      let fileObj = {
        percentage: 1,
        name: file.name,
        size: file.size,
        url: '',
        loading: true,
        attachment_type: file.name.slice(file.name.lastIndexOf('.') + 1),
        id: Math.random(),
        source: CancelToken.source(),
      }
      _this.$emit("onUploadProgress", fileObj)
      try {
        const _data = {
          upload_type: this.upload_type,
          type: this.type,
          attachment_name: file.name,
        };
        if (this.upload_type === "database") {
          //如果上传类型为“资料库”，则请求参数需加 pid
          _data.pid = this.pid;
        }
        let res
        let params = {
          attachment_name: file.name,
        }
        if(this.upload_type === 'cross') {
          res = await uploadApi.getCrossProjectAttachmentUploadPolicy(params)
        } else if (this.upload_type === 'product') {
          res = await uploadApi.getProductAttachmentUploadPolicy(params)
        } else {
          res = await uploadApi.getPolicy(_data);
        }
        // console.log(res)
        // let res
        // if (this.pid) {
        //   res = await uploadApi.getOrdinaryAttachmentUploadPolicy({ type: this.type, attachment_name: file.name, pid: this.pid, file_cabinet_id: this.fileable_id })
        // } else {
        //   res = await uploadApi.getPolicy({ type: this.type, attachment_name: file.name })
        // }
        if (res) {
          let dataset = new FormData();
          dataset.append("name", res.oss_attachment_name);
          dataset.append("key", res.dir + res.oss_attachment_name);
          dataset.append("policy", res.policy);
          dataset.append("OSSAccessKeyId", res.accessid);
          dataset.append("success_action_status", "200");
          dataset.append("callback", res.callback);
          dataset.append("Content-Disposition", `attachment; filename="${file.name}"`);
          if (this.public) {
             dataset.append("x-oss-object-acl", "public-read");
          }
          dataset.append("signature", res.signature);
          dataset.append("file", file.raw || file);
          console.log(file);
          let httpDefaultOpts = {
            baseURL: "",
            method: "post",
            cache: false,
            url: process.env.NODE_ENV === "development" ? "airworthiness_certified" : res.host,
            timeout: 0,
            data: dataset,
            onUploadProgress: (a) => {
              let count = parseInt(100 * (a.loaded / a.total));
              fileObj.percentage = count > 99 ? (count = 99) : count;
              fileObj.name = res.oss_attachment_name;
              fileObj.attachment_name = file.name;
              fileObj.size = file.size;
              fileObj.type = file.name.slice(file.name.lastIndexOf(".") + 1);
              // file.name = res.oss_attachment_name
              file.percentage = count;
              _this.$emit("onUploadProgress", fileObj, this.files);
            },
            cancelToken: fileObj.source.token,
            headers: { "Content-Type": "multipart/form-data", Accept: "*/*" },
          };
          // console.log(httpDefaultOpts)
          let result = await instance(httpDefaultOpts);
          this.getFileUrl(fileObj, result.data.data, file);
        }
      } catch (error) {
        this.delFilesList();
        console.log(error);
      }
    },
    getFileUrl(file, data, fl) {
      // uploadApi.getFileUrl({ oss_attachment_name: data.oss_attachment_name }).then(res => {
      //   let result = JSON.parse(JSON.stringify(data))
      //   result.attachment_link = res.sign_url
      //   file.percentage = 100
      //   file.loading = false
      //   fl.percentage = 100
      //   Object.assign(file, result)
      //   this.$emit('onUploadProgress', JSON.parse(JSON.stringify(file)), JSON.parse(JSON.stringify(this.files)))
      //   this.delFilesList() // 删除上传完成项
      // }).catch(err => {
      //   console.log(err)
      // })
      let result = JSON.parse(JSON.stringify(data));
      // result.attachment_link = res.sign_url
      file.percentage = 100;
      file.loading = false;
      fl.percentage = 100;
      Object.assign(file, result);
      this.$emit("onUploadProgress", JSON.parse(JSON.stringify(file)), JSON.parse(JSON.stringify(this.files)));
      this.delFilesList(); // 删除上传完成项
    },
    delFilesList() {
      this.count = this.count + 1;
      if (this.count === this.files.length) {
        this.files = [];
        this.count = 0;
      }
    },
    upload() {
      this.$refs["upload"].$el.getElementsByClassName("el-upload__input")[0].click();
    },
    success() {
      console.log("上传完成--");
    },
    beforeAvatarUpload(file) {
      console.log('-------------', file)
      const isLt = file.size / 1024 / 1024 < this.fileSize;

      if (!isLt) {
        this.$message.error(`上传文件大小不能超过 ${this.fileSize}MB!`);
      }
      return isLt;
    },
    cancelUploadItem(file) {
      this.$refs.upload.abort(file);
    },
  },
};
</script>
<style lang="scss">
.upload-oss {
}
</style>
